import dynamic from "next/dynamic";
import TagItemsGridConfig from "./tag-items-grid-config";
import TagItemsGridAdvancedConfig from "./tag-items-grid-advanced-config";
const TagItemsGridComponent = dynamic(()=>import("./tag-items-grid-component"));
export default {
    TagItemsGridComponent,
    TagItemsGridConfig,
    TagItemsGridAdvancedConfig
};
